import React from 'react';

import { FormattedMessage } from 'react-intl';

import {
  ACTION_TYPE_ADD_TAG,
  ACTION_TYPE_ADD_TAX_IDENTIFERS,
  ACTION_TYPE_INSURE_PACKAGE,
  ACTION_TYPE_REQUEST_CONFIRMATION,
  ACTION_TYPE_ADD_INTERNAL_NOTE,
  ACTION_TYPE_HOLD_ORDER_FOR,
  ACTION_TYPE_SET_CUSTOMS_CONTENT_TYPE,
  ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY,
  ACTION_TYPE_SET_SHIP_FROM_LOCATION,
  ACTION_TYPE_CREATE_ALERT,
  ACTION_TYPE_SET_ORDER_TOTAL_WEIGHT,
  ACTION_TYPE_SET_PACKAGE_DIMENSIONS,
  ACTION_TYPE_ADJUST_ORDER_WEIGHT,
  ACTION_TYPE_USE_SHIPMENT_NOTIFICATION_TEMPLATE,
  ACTION_TYPE_USE_PACKING_SLIP,
  ACTION_TYPE_ADD_NOTE_TO_BUYER,
  ACTION_TYPE_ASSIGN_TO_USER,
  ACTION_TYPE_SET_CUSTOM_FIELD_ONE,
  ACTION_TYPE_SET_CUSTOM_FIELD_TWO,
  ACTION_TYPE_SET_CUSTOM_FIELD_THREE,
  ACTION_TYPE_SET_DRY_ICE_WEIGHT,
  ACTION_TYPE_SET_DECLARATION_STATEMENT,
  ACTION_TYPE_USE_DELIVERY_NOTIFICATION_EMAIL_TEMPLATE,
  ACTION_TYPE_SET_SHIP_BY_DATE,
  ACTION_TYPE_SEND_AN_EMAIL,
  ACTION_TYPE_HOLD_UNTIL,
  ACTION_TYPE_CHARGE_SHIPPING_TO_MY_ACCOUNT,
  ACTION_TYPE_DELEGATE_TO_ASSIGNED_FULFILLMENT_PROVIDER,
  ACTION_TYPE_SET_DELIVER_BY_DATE,
  ACTION_TYPE_SET_SHIP_DATE,
  ACTION_TYPE_ADD_MOVEMENT_INDICATOR,
} from '../../../../constants/action-types';
import messages from './messages';

const labelToInputTypeMap = {
  [ACTION_TYPE_ADD_TAG]: <FormattedMessage {...messages.addTagLabel} />,
  [ACTION_TYPE_ADD_TAX_IDENTIFERS]: <FormattedMessage {...messages.addTaxIdentifiersLabel} />,
  [ACTION_TYPE_CREATE_ALERT]: <FormattedMessage {...messages.createAlertLabel} />,
  [ACTION_TYPE_SET_DECLARATION_STATEMENT]: <FormattedMessage {...messages.declarationStatementLabel} />,
  [ACTION_TYPE_SET_PACKAGE_DIMENSIONS]: <FormattedMessage {...messages.dimensionsLabel} />,
  [ACTION_TYPE_ASSIGN_TO_USER]: <FormattedMessage {...messages.assignUserLabel} />,
  [ACTION_TYPE_SET_SHIP_FROM_LOCATION]: <FormattedMessage {...messages.setShipFromLabel} />,
  [ACTION_TYPE_USE_SHIPMENT_NOTIFICATION_TEMPLATE]: <FormattedMessage {...messages.useShipmentNotificationLabel} />,
  [ACTION_TYPE_USE_PACKING_SLIP]: <FormattedMessage {...messages.usePackingSlipLabel} />,
  [ACTION_TYPE_USE_DELIVERY_NOTIFICATION_EMAIL_TEMPLATE]: <FormattedMessage {...messages.useDeliveryNotificationLabel} />,
  [ACTION_TYPE_HOLD_ORDER_FOR]: <FormattedMessage {...messages.holdOrderForLabel} />,
  [ACTION_TYPE_SET_SHIP_BY_DATE]: <FormattedMessage {...messages.setShipByLabel} />,
  [ACTION_TYPE_ADD_INTERNAL_NOTE]: <FormattedMessage {...messages.addInternalNoteLabel} />,
  [ACTION_TYPE_ADD_NOTE_TO_BUYER]: <FormattedMessage {...messages.addNoteToBuyerLabel} />,
  [ACTION_TYPE_SET_ORDER_TOTAL_WEIGHT]: <FormattedMessage {...messages.setOrderTotalWeightLabel} />,
  [ACTION_TYPE_ADJUST_ORDER_WEIGHT]: <FormattedMessage {...messages.adjustOrderWeightLabel} />,
  [ACTION_TYPE_SET_CUSTOM_FIELD_ONE]: <FormattedMessage {...messages.customFieldOneLabel} />,
  [ACTION_TYPE_SET_CUSTOM_FIELD_TWO]: <FormattedMessage {...messages.customFieldTwoLabel} />,
  [ACTION_TYPE_SET_CUSTOM_FIELD_THREE]: <FormattedMessage {...messages.customFieldThreeLabel} />,
  [ACTION_TYPE_INSURE_PACKAGE]: <FormattedMessage {...messages.insurePackageLabel} />,
  [ACTION_TYPE_REQUEST_CONFIRMATION]: <FormattedMessage {...messages.requestConfirmationLabel} />,
  [ACTION_TYPE_SET_CUSTOMS_CONTENT_TYPE]: <FormattedMessage {...messages.setCustomsContentTypeLabel} />,
  [ACTION_TYPE_SET_INTERNATIONAL_NON_DELIVERY]: <FormattedMessage {...messages.setInternationalNonDeliveryLabel} />,
  [ACTION_TYPE_SET_DRY_ICE_WEIGHT]: <FormattedMessage {...messages.setDryIceWeightLabel} />,
  [ACTION_TYPE_SEND_AN_EMAIL]: <FormattedMessage {...messages.sendEmailLabel} />,
  [ACTION_TYPE_HOLD_UNTIL]: <FormattedMessage {...messages.holdUntilLabel} />,
  [ACTION_TYPE_CHARGE_SHIPPING_TO_MY_ACCOUNT]: <FormattedMessage {...messages.chargeToMyAccountLabel} />,
  [ACTION_TYPE_DELEGATE_TO_ASSIGNED_FULFILLMENT_PROVIDER]: <FormattedMessage {...messages.serviceLabel} />,
  [ACTION_TYPE_SET_DELIVER_BY_DATE]: <FormattedMessage {...messages.setDeliverByLabel} />,
  [ACTION_TYPE_SET_SHIP_DATE]: <FormattedMessage {...messages.setShipDateLabel} />,
  [ACTION_TYPE_ADD_MOVEMENT_INDICATOR]: <FormattedMessage {...messages.addMovementIndicatorLabel} />,
};

export const componentLabelFromActionType = (actionType) => {
  if (!labelToInputTypeMap[actionType]) {
    return <FormattedMessage {...messages.labelNotFound} />;
  }
  return labelToInputTypeMap[actionType];
};
